<template>
  <div v-loading="loading" class="page-content_wrapper preview-detail">
    <template v-if="detail">
      <div class="preview-title">{{ detail.title }}</div>
      <div class="preview-state-info">
        <div class="preview-state-info-left">
          <div class="preview-state-info-item preview-release-time">发布时间：{{ detail.createTime }}</div>
          <div class="preview-state-info-item preview-view-amount">浏览量：{{ Math.max(detail.readingAmount || 0, 0) }}</div>
          <div class="preview-state-info-item preview-collect-amount">收藏量：{{ Math.max(detail.collectionCount || 0, 0) }}</div>
        </div>
        <div class="preview-state-info-item preview-state">
          项目状态：<span class="state-tag">预告中</span>
        </div>
      </div>
      <panel class="preview-wrapper" title="招标正文" icon="assets/images/icon-template-blue.png">
        <template slot="right">
          <div class="preview-actions">
            <!-- 收藏相关 -->
            <el-button
              v-if="detail.collectionType"
              class="cancel-collect-button"
              @click="cancelCollect"
            >取消收藏</el-button>
            <el-button
              v-else
              class="collect-button"
              @click="collect"
            >收藏项目</el-button>
          </div>
        </template>
        <div class="preview-content">{{ detail.text }}</div>
      </panel>
    </template>
  </div>
</template>

<script>
import Panel from '@/components/Panel'

import { mapState } from 'vuex'
import loginCheck from '@/mixins/loginCheck'

import {
  fetchPreviewDetail,
  collectPreview,
  cancelCollectPreview
} from '@/api'

export default {

  components: {
    Panel
  },
  mixins: [loginCheck],

  data() {
    return {
      detail: '',

      loading: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ])
  },

  created() {
    this.fetchDetail(this.$route.query.id)
  },

  methods: {
    /*
     * 收藏预告
     */
    async collect() {
      if (this.loginCheck()) {
        try {
          await collectPreview({ id: this.$route.query.id })

          this.detail.collectionType = true
          this.detail.collectionCount++
          this.$message.success('收藏成功！')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 取消收藏
     */
    async cancelCollect() {
      if (this.loginCheck()) {
        try {
          await cancelCollectPreview({ id: this.$route.query.id })

          this.detail.collectionType = false
          this.detail.collectionCount--
          this.$message.success('取消收藏成功！')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 获取详情
     */
    async fetchDetail(id) {
      this.loading = true

      try {
        const res = await fetchPreviewDetail({ id })

        this.detail = res.data
      } catch (error) {
        this.$message.error(error.message)
      }

      this.loading = false
    }
  }
}
</script>

<style lang='scss' scoped>
.preview-detail {
  padding-top: 34px;
  padding-bottom: 60px;
  .preview-title {
    font-size: 26px;
    line-height: 40px;
    font-weight: bold;
  }
  .preview-state-info {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 0 8px;
    margin: 40px 0 0;
    .preview-state-info-item {
      display: flex;
      align-items: center;
      min-width: 280px;
      padding: 0 0 0 25px;
      background-repeat: no-repeat;
      background-position: center left;
      color: #b3b3b3;
      line-height: 20px;
      white-space: nowrap;
      margin: 0 20px 10px 0;
    }
    .preview-state-info-left {
      display: flex;
      flex-wrap: wrap;
    }
    .preview-release-time {
      background-image: url("~@/assets/images/icon-clock.png");
    }
    .preview-view-amount {
      background-image: url("~@/assets/images/icon-eye.png");
    }
    .preview-collect-amount {
      background-image: url("~@/assets/images/icon-aim.png");
    }
    .preview-state {
      min-width: auto;
      background-image: url("~@/assets/images/icon-text.png");
      padding: 0 0 0 22px;
      .state-tag {
        height: 20px;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        border-radius: 4px;
        text-align: center;
        padding: 0 4px;
        background-color: #ff8a00;
        margin: 0 0 0 8px;
      }
    }
  }
  .preview-wrapper {
    margin: 34px 0 0;
    /deep/ .panel-header {
      align-items: flex-end;
      .panel-title {
        font-size: 20px;
        line-height: inherit;
      }
    }
    .preview-actions {
      .el-button {
        width: 126px;
        font-size: 16px;
        + .el-button {
          margin: 0 0 0 20px;
        }
      }
      .collect-button {
        color: #417ef7;
        border-color: currentColor;
      }
      .cancel-collect-button {
        color: #666;
        border-color: #e6e6e6;
      }
    }

    .preview-content {
      line-height: 26px;
      color: #666;
      white-space: pre-wrap;
      padding: 30px 0 0;
    }
  }
}
</style>
